import React from "react";
import styled from "styled-components";
import KnopLogo from "../assets/KnopLogo.svg?react";
import { useMsalAccount } from "../auth/hooks/useMsalAccount";
import { config } from "@shared/envVariables";

export function LoginPage(): React.JSX.Element {
  const { instance } = useMsalAccount();

  function handleLoginClick() {
    instance.loginRedirect({ scopes: [config.azureAd.scope] }).catch((error) => {
      console.error("Login failed", error);
    });
  }

  return (
    <Container>
      <FormContainer>
        <InnerContainer>
          <KnopLogo strokeWidth={0} />
          <h4>Inloggen KnoP</h4>
          <tractie-button
            data-testid="login-page-login-button"
            level="primary"
            onClick={handleLoginClick}
          >
            Login
          </tractie-button>
        </InnerContainer>
      </FormContainer>
    </Container>
  );
}

const FormContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 496px;
  padding: ${(props) => props.theme.spacing.spacing2.toString()};
  border-radius: ${(props) => props.theme.spacing.spacing3.toString()};
  background-color: ${(props) => props.theme.colors.background};
`;

const InnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.spacing6.toString()};
  min-width: 300px;
  margin: ${(props) => props.theme.spacing.spacing14.toString()};

  h4 {
    font-weight: var(--tractie-typography-weight-medium);
    margin: 0;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100svh;
  width: 100svw;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.spacing6.toString()};
  background-color: ${(props) => props.theme.colors.backgroundSunken};

  h3 {
    font-size: ${(props) => props.theme.typography.size2XL.toString()};
    font-weight: ${(props) => props.theme.typography.weightBold.toString()};
  }
`;
